(ns ui.view.transaction-process.cards.declarations
  (:require
   [common.localization :refer [tr]]
   [re-frame.core :as rf]
   [ui.util :as uu]
   [ui.view.transaction-process.cards.card-header :as card-header]
   [ui.view.transaction-process.event :as event]
   [ui.view.transaction-process.modals.declaration.event :as declaration-event]
   [ui.view.transaction-process.sub :as sub]
   [ui.view.transaction-process.util :as tp-util]))

(defn- declaration-status-badge
  [declaration]
  (let [[label variant] (cond
                          (:declaration/draft? declaration)
                          [(tr :draft) :warning]
                          (:declaration/not-applicable? declaration)
                          [(tr :not-applicable) :neutral]
                          (:declaration/completed? declaration)
                          [(tr :completed) :success]
                          :else
                          [(tr :pending) :warning])]
    [tp-util/status-badge {:label label :variant variant}]))

(defn- declaration-row
  [{:keys [label declaration can-write? on-click]}]
  (let [has-declaration? (some? declaration)
        clickable? (or has-declaration? can-write?)]
    [:div {:class (uu/cm "border rounded-lg p-4 flex items-center justify-between"
                         (when clickable? "cursor-pointer hover:bg-gray-50")
                         (cond
                           (and has-declaration? (:declaration/completed? declaration))
                           "border-primary-regular/30 bg-primary-regular/5"

                           (and has-declaration? (:declaration/not-applicable? declaration))
                           "border-gray-200"

                           has-declaration?
                           "border-yellow-200 bg-yellow-50/50"

                           :else
                           "border-gray-200"))
           :on-click (when clickable? on-click)}
     [:div
      [:span {:class "text-sm m-0 text-gray-900 block"}
       label]
      [:div {:class "mt-1"}
       (if has-declaration?
         [declaration-status-badge declaration]
         [tp-util/status-badge {:label (tr :not-started) :variant :neutral}])]]
     [:div {:class "flex items-center gap-2"}
      (when (and (not has-declaration?) can-write?)
        [:span {:class "px-3 py-1 text-sm m-0 border border-gray-300 rounded"}
         (tr :transaction-process/log)])
      (when has-declaration?
        [:span {:class "w-8 h-8 flex items-center justify-center rounded text-gray-400 hover:text-gray-600 hover:bg-gray-100"}
         [:svg {:class            "w-4 h-4"
                :xmlns            "http://www.w3.org/2000/svg"
                :viewBox          "0 0 24 24"
                :fill             "none"
                :stroke           "currentColor"
                :stroke-width     "2"
                :stroke-linecap   "round"
                :stroke-linejoin  "round"}
          [:polyline {:points "9 6 15 12 9 18"}]]])]]))

(defn display-declaration-slot?
  [{:keys [entry instance lookup]}]
  (and (tp-util/resolve-required? {:entry entry :lookup lookup})
       (tp-util/slot-in-scope? {:rule-lookup lookup
                                :entry       entry
                                :instance    instance})))

(defn view
  [{:keys [card ctx]}]
  (let [matched @(rf/subscribe [::sub/matched-declarations ctx])
        process  @(rf/subscribe [::sub/process ctx])
        lookup process
        can-write-declarations? @(rf/subscribe [::sub/can-write-field? ctx :declaration/completed?])
        ;; slot-kw -> resolved {:slot-kw :entry :instance}
        by-slot (->> matched
                     (map (fn [m] [(:slot-kw m) m]))
                     (into {}))
        ;; Iterate the card's layout slots in order; the resolved instance comes
        ;; from `by-slot`.
        slots (:card/slots card)]
    [:div {:class "bg-white rounded-lg border border-gray-200 p-6"}
     [card-header/view {:card card}]
     [:div {:class "flex flex-col gap-2"}
      (for [slot-kw slots
            :let [{:keys [entry instance]} (get by-slot slot-kw)]
            :when entry]
        (let [label       (:slot/label entry)
              display?    (display-declaration-slot? {:entry    entry
                                                      :instance instance
                                                      :lookup   lookup})]
          (when display?
            ^{:key slot-kw}
            [declaration-row
             {:label       label
              :declaration instance
              :can-write?  can-write-declarations?
              :on-click    (fn []
                             (cond
                               (and instance can-write-declarations?)
                               (rf/dispatch [::declaration-event/open ctx
                                             {:slot-kw                 slot-kw
                                              :declaration-type-label  label
                                              :existing-declaration    instance}])

                               instance
                               (rf/dispatch [::event/set-detail-panel ctx
                                             {:panel-type :declaration
                                              :item       {:slot-kw            slot-kw
                                                           :entry              entry
                                                           :declaration-entity instance
                                                           :label              label}}])

                               can-write-declarations?
                               (rf/dispatch [::declaration-event/open ctx
                                             {:slot-kw                 slot-kw
                                              :declaration-type-label  label}])))}])))]]))
